<ht-modal #modal [options]="modalOptions" (closeModalOutput)="onGotIt()">
  <p>{{ 'shared.activeCallWarning.body' | translate }}</p>
</ht-modal>
